import { useQuery } from '@tanstack/react-query'
import { GET_GLOBAL_WHATS_NEW_KEY } from '../constants/queryKeys'
import getGlobalWhatsNew from '../api/whatsnew/getGlobalWhatsNew'
import { GlobalWhatsNewResponse } from '../types/globalWhatsNew'

const useGlobalWhatsNew = () => {
  return useQuery<GlobalWhatsNewResponse>([GET_GLOBAL_WHATS_NEW_KEY], () =>
    getGlobalWhatsNew(),
  )
}

export default useGlobalWhatsNew
